import { Component, Input, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'project-admin-ai-flow',
    template: require('./project.admin.ai-flow.html')
})
export class ProjectAdminAiFlowComponent implements OnInit {
    @Input() project: any;
    @Input() isProjectAdmin: any;

    constructor(private titleService: Title) {}

    ngOnInit(): void {
        this.titleService.setTitle('AI Flow Settings');
    }
}
